import { render, staticRenderFns } from "./UserArticles.vue?vue&type=template&id=3850c89a&scoped=true"
import script from "./UserArticles.vue?vue&type=script&lang=ts"
export * from "./UserArticles.vue?vue&type=script&lang=ts"
import style0 from "./UserArticles.vue?vue&type=style&index=0&id=3850c89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3850c89a",
  null
  
)

export default component.exports